import { render, staticRenderFns } from "./PracticeCreate.vue?vue&type=template&id=a1959fb8&"
import script from "./PracticeCreate.vue?vue&type=script&lang=js&"
export * from "./PracticeCreate.vue?vue&type=script&lang=js&"
import style0 from "./PracticeCreate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports